import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { ServiceFileValidationDataTypes } from "../../../../Schema/serviceFileValidation.types";
import { ValidationFormTypes } from "../../../../Pages/SubmitProccess/ValidationForm/ValidationForm";
import { setValidationData } from "../../validationData/validationData";
import { resetFiles } from "../../files/uploadedFiles/uploadedFiles";

export type ServiceFileValidationLoadAction = {
  type: string;
  payload: ValidationFormTypes;
};

export type ServiceFileValidationData = {
  data: {
    validate_res: ServiceFileValidationDataTypes;
  };
};

export const ServiceFileValidation = new ReduxFetchState<
  ServiceFileValidationData,
  ValidationFormTypes,
  any
>("serviceFileValidation");

export function* watchServiceFileValidation(
  action: ServiceFileValidationLoadAction,
) {
  try {
    const { id, file_ids, question_id, file_link, user_service_id } =
      action.payload;

    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: ServiceFileValidationData = yield axios({
      url: `/api/v1/ai/service/${id}/file-validation`,
      method: "POST",
      headers: {
        lang,
      },
      data: { file_ids, question_id, user_service_id, file_link },
    });

    yield put(ServiceFileValidation.actions.loadSuccess({ data: data.data }));
    if (question_id) {
      yield put(setValidationData({ ...data.data.validate_res, question_id }));
    }
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(ServiceFileValidation.actions.loadFailure(e.message));
  }
}

export function* serviceFileValidationSagas() {
  yield takeEvery(
    ServiceFileValidation.actionTypes.load,
    watchServiceFileValidation,
  );
}

export function useServiceFileValidation() {
  const { loading, data, ...serviceFileValidationState } = useAppSelector(
    (state) => state.serviceFileValidation,
  );
  const dispatch = useAppDispatch();

  const dispatchServiceFileValidation = useCallback(
    (data: ValidationFormTypes) => {
      dispatch(ServiceFileValidation.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...serviceFileValidationState,
    dispatchServiceFileValidation,
    serviceFileValidationLoading: loading,
    serviceFileValidationData: data,
  };
}

export const {
  actionTypes: serviceFileValidationActionsTypes,
  actions: serviceFileValidationActions,
  reducer: serviceFileValidationReducer,
} = ServiceFileValidation;
